<template>
  <div class="map-legend-container">
    <div class="map-legend-layer-header">
      <div class="map-legend-title">{{ item.name }}</div>
      <div class="map-legend-count">{{ item.count }} ({{ item.allCount }})</div>
    </div>
    <div class="map-legend-subtitle">{{ item.geom_type }}</div>
    <div class="map-legend-row">
      <div
        v-if="item.type === 'basic' || item.type === 'tile_layer'"
        class="map-legend-color"
        :style="getLegendColor(item)"
      />
      <div v-else class="map-legend-icon">
        <img :src="`${baseURL}/${downloadURL}/${item.icon}`" />
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants/url";

export default {
  props: ["item", "get-legend-color"],
  data() {
    return {
      baseURL: constants.URL,
      downloadURL: "download_share_resource"
    };
  }
};
</script>

<style></style>
